import CloseOutlined from "@mui/icons-material/CloseOutlined";
import { IconButton, Modal } from "@mui/material";
import ContactDetails from "./ContactDetails";
import "./ContactDetailsModal.css";
import "../Components/Components.css";

const ContactDetailsModal = ({
  changePage,
  contactID,
  isOpen,
  setIsContactDetailsModalShown,
  setSelected,
  setIsAddEditContactDialogShown,
  setIsLinking,
  setMergeSource,
}) => {
  const handleClose = () => {
    setIsContactDetailsModalShown(false);
    setSelected && setSelected(null);
  };

  return (
    <Modal
      open={isOpen}
      className="modal contact-details"
      onClose={handleClose}
    >
      <div className="modal-container">
        <div className="modal-content">
          <h2 className="title">Contact Detail</h2>
          <IconButton className="close-button" onClick={handleClose}>
            <CloseOutlined />
          </IconButton>

          <ContactDetails
            changePage={changePage}
            contactID={contactID}
            setIsContactDetailsModalShown={setIsContactDetailsModalShown}
            setIsAddEditContactDialogShown={setIsAddEditContactDialogShown}
            setIsLinking={setIsLinking}
            setMergeSource={setMergeSource}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ContactDetailsModal;
